import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import EltStoreService from 'legacy/lut/classes/services/EltStoreService'

interface IFetchDataPayload {
  partnerId: string
  forceUpdate: boolean
  groupId?: number | null
}

export const fetchFormData = async ({
  forceUpdate = false,
  groupId = null,
  partnerId,
}: IFetchDataPayload): Promise<IELTData[]> => {
  return EltStoreService.getEltData({
    pid: partnerId,
    groupId: groupId,
    forceUpdate,
  })
}
